import axios from 'axios'
import { generateBaseUri } from 'utils/helper'

export const getMarketplaceConnects = (params) => {
  return axios.get('/marketplaceConnects', { params })
}

export const getMarketplaceConnectShopeeAuthUrl = () => {
  return axios.get('/marketplaceConnects/shopee/partnerAuthUrl')
}

export const getMarketplaceConnectLazadaAuthUrl = () => {
  return axios.get('/marketplaceConnects/lazada/partnerAuthUrl')
}

export const generateMarketplaceConnectLazadaCallbackUrl = ({ websiteId, code }) => {
  const baseUri = generateBaseUri({ ignoreInitEndpoint: true }).replace(/\/api\/v1\/?$/, '')
  return `${baseUri}/marketplace-connect/lazadaErp/callback/${websiteId}?code=${encodeURIComponent(code)}`
}

export const getMarketplaceConnectTiktokAuthUrl = () => {
  return axios.get('/marketplaceConnects/tiktok/partnerAuthUrl')
}

export const getMarketplaceConnect = (id) => {
  return axios.get(`/marketplaceConnects/${id}`)
}

export const syncMarketplaceConnect = (id) => {
  return axios.post(`/marketplaceConnects/${id}/sync`)
}

export const addTempMarketplaceConnect = (data) => {
  return axios.post(`/marketplaceConnects/tmp`, data)
}

export const deleteMarketplaceConnect = (id) => {
  return axios.delete(`/marketplaceConnects/${id}`)
}

export const editMarketplaceConnect = (data) => {
  return axios.put(`/marketplaceConnects/${data.id}`, data)
}

export const getMarketplaceConnectTokopedia = (params) => {
  return axios.get('/marketplaceConnects/tokopedia', { params })
}

export const getMarketplaceShopeeCategories = (lang) => {
  return axios.get('/marketplaceConnects/shopee/products/category', { params: { lang } })
}

export const getMarketplaceShopeeCategoryAttributes = (categoryId, lang) => {
  return axios.get('/marketplaceConnects/shopee/products/categoryAttribute', {
    params: { category_id: categoryId, lang },
  })
}

export const getMarketplaceShopeeBrandList = (params) => {
  return axios.get('/marketplaceConnects/shopee/products/brandList', { params })
}

export const getMarketplaceShopeeChannelList = (connect_id) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/products/channelList`)
}

export const getMarketplaceTiktokCategories = (params) => {
  return axios.get('/marketplaceConnects/tiktok/products/category', { params })
}

export const getMarketplaceTiktokCategoryAttributes = (params) => {
  return axios.get('/marketplaceConnects/tiktok/products/categoryAttribute', { params })
}

export const getMarketplaceTiktokBrandList = (params) => {
  return axios.get('/marketplaceConnects/tiktok/products/brandList', { params })
}

export const getMarketplaceTiktokDeliveryOptions = ({ connect_id }) => {
  return axios.get(`/marketplaceConnects/tiktok/${connect_id}/products/deliveryOptions`)
}

export const uploadMarketplaceTiktokImage = ({ connect_id, file, use_case }) => {
  const form = new FormData()
  form.append('image', file)
  form.append('use_case', use_case)
  return axios.postForm(`/marketplaceConnects/tiktok/${connect_id}/uploadImage`, form)
}

export const publishPosProductToTiktok = ({ connect_id, data }) => {
  return axios.post(`/marketplaceConnects/tiktok/${connect_id}/publishPosProduct`, data)
}

export const updateTiktokMarketplaceConnectProduct = ({ connect_id, product_id, data }) =>
  axios.put(`/marketplaceConnects/tiktok/${connect_id}/products/${product_id}`, data)

export const getMarketplaceConnectProducts = (id, params) => {
  return axios.get(`/marketplaceConnects/${id}/products`, { params })
}

export const getAllMarketplaceConnectProducts = (params) => {
  return axios.get('/marketplaceConnects/products', { params })
}

export const syncMarketplaceConnectProducts = ({ id, ...data }) => {
  return axios.post(`/marketplaceConnects/${id}/products/sync`, data)
}

export const pushMarketplaceConnectProductDetail = ({ connect_id, product_id }) => {
  return axios.post(`/marketplaceConnects/${connect_id}/products/${product_id}/pushDetail`)
}

export const pullMarketplaceConnectProducts = ({
  connect_id,
  ids,
  apply_detail_to_pos_product,
  linking_strategy,
}) => {
  const payload = { ids, apply_detail_to_pos_product }
  if (linking_strategy !== undefined) {
    payload.linking_strategy = linking_strategy
  }
  return axios.post(`/marketplaceConnects/${connect_id}/products/pull`, payload)
}

export const linkMarketplaceConnectProductPosProduct = ({
  connect_id,
  product_id,
  pos_product_id,
}) => {
  return axios.patch(`/marketplaceConnects/${connect_id}/products/${product_id}/posProduct`, {
    pos_product_id,
  })
}

export const generateMarketplaceConnectProductPosProduct = ({ connect_id, product_id }) => {
  return axios.post(`/marketplaceConnects/${connect_id}/products/${product_id}/generatePosProduct`)
}

export const generateMarketplaceConnectProductPosProducts = ({ connect_id, ids }) => {
  return axios.post(`/marketplaceConnects/${connect_id}/products/generatePosProducts`, { ids })
}

export const deleteMarketplaceConnectProductListing = (params) => {
  const { connect_id, product_id } = params
  return axios.delete(`/marketplaceConnects/${connect_id}/products/${product_id}/listing`)
}

export const deleteMarketplaceConnectProduct = (params) => {
  const { connect_id, product_id } = params
  return axios.delete(`/marketplaceConnects/${connect_id}/products/${product_id}`)
}

export const publishPosProductToShopee = ({ connect_id, data }) => {
  return axios.post(`/marketplaceConnects/shopee/${connect_id}/publishPosProduct`, data)
}

export const uploadMarketplaceShopeeImage = ({ connect_id, file }) => {
  const form = new FormData()
  form.append('image', file)
  return axios.postForm(`/marketplaceConnects/shopee/${connect_id}/uploadImage`, form)
}

export const getMarketplaceShopeeItemLimit = ({ connect_id, category_id }) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/products/itemLimit`, {
    params: { category_id },
  })
}

export const getMarketplaceShopeeSizeCharts = ({ connect_id, category_id, page_size, cursor }) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/products/sizeCharts`, {
    params: { category_id, page_size, cursor },
  })
}

export const getMarketplaceShopeeSizeChartDetail = ({ connect_id, size_chart_id }) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/products/sizeCharts/${size_chart_id}`)
}

export const marketplaceShopeeProductBoosts = ({ connect_id, data }) => {
  return axios.patch(`/marketplaceConnects/shopee/${connect_id}/productBoosts`, data)
}

export const getMarketplaceShopeeProductBoost = ({ connect_id }) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/productBoost`)
}

export const getMarketplaceShopeeBoostedProducts = ({ connect_id }) => {
  return axios.get(`/marketplaceConnects/shopee/${connect_id}/boosted`)
}

export const unlistShopeeMarketplaceConnectProduct = ({ connect_id, product_id }) => {
  return axios.patch(`/marketplaceConnects/shopee/${connect_id}/products/${product_id}/unlist`)
}

export const listShopeeMarketplaceConnectProduct = ({ connect_id, product_id }) => {
  return axios.patch(`/marketplaceConnects/shopee/${connect_id}/products/${product_id}/list`)
}

export const activateTiktokMarketplaceConnectProduct = ({ connect_id, product_id }) => {
  return axios.patch(`/marketplaceConnects/tiktok/${connect_id}/products/${product_id}/activate`)
}

export const deactivateTiktokMarketplaceConnectProduct = ({ connect_id, product_id }) => {
  return axios.patch(`/marketplaceConnects/tiktok/${connect_id}/products/${product_id}/deactivate`)
}

export const getMarketplaceChartSalesPieByMarketplace = (params) => {
  return axios.get('/marketplaceConnects/charts/salesPieByMarketplace', { params })
}

export const getMarketplaceChartSalesBarMonthlyByMarketplace = (params) => {
  return axios.get('/marketplaceConnects/charts/salesBarMonthlyByMarketplace', { params })
}

export const getMarketplacePosProductLinkBarChart = (params) => {
  return axios.get('/marketplaceConnects/product/posProductLinkBarChart', { params })
}

export const getMarketplaceConnectProduct = (connect_id, product_id) =>
  axios.get(`/marketplaceConnects/${connect_id}/products/${product_id}`)

export const updateShopeeMarketplaceConnectProduct = ({ connect_id, product_id, data }) =>
  axios.put(`/marketplaceConnects/shopee/${connect_id}/products/${product_id}`, data)

export const inputMassPatchMarketplaceProduct = (data) =>
  axios.post('/marketplaceConnects/product/inputMassPatch', data)

export const executeMassPatchMarketplaceProduct = (data) =>
  axios.patch('/marketplaceConnects/product/executeMassPatch', data)

export const getMarketplaceConnectFailedSyncLogs = (connect_id, params) =>
  axios.get(`/marketplaceConnects/${connect_id}/products/failedSync`, { params })

export const getAllMarketplaceConnectFailedSyncLogs = (params) =>
  axios.get('/marketplaceConnects/product/failedSyncs', { params })

export const getMarketplaceConnectSyncHistories = (params) =>
  axios.get('/marketplaceConnects/product/syncHistories', { params })

export const getGroupedByProductMarketplaceProducts = (params) =>
  axios.get('/marketplaceConnects/products/groupedByProduct', { params })

export const updateMarketplaceConnectProductSyncStock = ({ connect_id, product_id, sync_stock }) =>
  axios.put(`/marketplaceConnects/${connect_id}/products/${product_id}/syncStock`, { sync_stock })

export const updateMarketplaceConnectProductPrice = ({
  connect_id,
  product_id,
  priced_manually,
  price,
}) => {
  const payload = { priced_manually }
  if (price !== undefined) {
    payload.price = price
  }
  return axios.put(`/marketplaceConnects/${connect_id}/products/${product_id}/price`, payload)
}
